class PredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector('#predictive-search-target')
    this.abortController = null

    if (!this.input || !this.predictiveSearchResults) return

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close()
      this.predictiveSearchResults.innerHTML = ''
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    if (this.abortController) this.abortController.abort()
    this.abortController = new AbortController()

    const params = new URLSearchParams()
    params.set('q', searchTerm)
    params.set('resources[type]', 'product,page,article,collection')
    params.set('resources[limit]', '10')
    params.set('resources[limit_scope]', 'each')
    params.set('section_id', 'predictive-search-results')

    fetch(`${window.Shopify?.routes?.root || '/'}search/suggest?${params.toString()}`, {
      signal: this.abortController.signal
    })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const section = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search-results')

        if (!section) {
          this.close()
          return
        }

        this.predictiveSearchResults.innerHTML = section.innerHTML
        this.open()
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return
        this.close()
        console.error(error)
      })
  }

  open() {
    this.predictiveSearchResults.hidden = false
    this.predictiveSearchResults.style.display = 'block'
    this.input.setAttribute('aria-expanded', 'true')
  }

  close() {
    this.predictiveSearchResults.hidden = true
    this.predictiveSearchResults.style.display = 'none'
    this.input.setAttribute('aria-expanded', 'false')
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
